import '../css/post-survey.scss'

const INSTRUCTIONS = [
  { text: <>This is <strong>not graded</strong> and has no effect on your course grade. Your work is recorded anonymously for research only.</> },
  { text: 'Use the AI however you naturally would — we\'re not judging how people use AI, we\'re trying to understand how to make it better support learning.' },
  { text: 'The first task will have AI assistance, the second will not. At the end, you\'ll spin a prize wheel as a thank-you. Give it your best shot.' },
]

export default function InstructionsModal({ onReady }) {
  return (
    <div className="survey-overlay">
      <div className="survey-modal">
        <div className="survey-header">
          <h2>Before You Start</h2>
        </div>
        <div className="survey-questions" style={{ padding: '24px 32px' }}>
          <p style={{ fontSize: '14px', color: '#6b7280', lineHeight: 1.7, margin: '0 0 24px' }}>
            This is a short practice activity to help us understand how students work with AI coding assistants. You'll do two quick tasks, 10 minutes each: one with an AI assistant, one without.
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {INSTRUCTIONS.map((item, i) => (
              <div key={i} style={{
                display: 'flex',
                gap: '12px',
                alignItems: 'flex-start',
                padding: '12px 14px',
                background: '#f9fafb',
                borderRadius: '8px'
              }}>
                <span style={{
                  width: '6px',
                  height: '6px',
                  borderRadius: '50%',
                  background: '#3b82f6',
                  flexShrink: 0,
                  marginTop: '8px'
                }} />
                <p style={{ fontSize: '13.5px', color: '#374151', lineHeight: 1.6, margin: 0 }}>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="survey-footer">
          <button className="survey-submit" onClick={onReady}>
            I'm ready →
          </button>
        </div>
      </div>
    </div>
  )
}